export default () => {
  const { $t } = useNuxtApp()

  const departments = [
    {
      key: 'BUSINESS',
      value: $t('labels.departments.business')
    },
    {
      key: 'ACCOUNTANT',
      value: $t('labels.departments.accountant')
    },
    {
      key: 'PERSONNEL',
      value: $t('labels.departments.personnel')
    },
    {
      key: 'LOGISTIC',
      value: $t('labels.departments.logistic')
    }
  ]

  return {
    departments
  }
}
